import logo from "../../assets/carret-logo.png";
import { LogoutOutlined } from "@ant-design/icons";
import { logoutHandler } from "../../utils";
import { useNavigate } from "react-router-dom";

const Header = ({ logoutEnable = true, view = false, url = "", children}) => {
  const navigate = useNavigate();

  const handleSwitch = () => {
    if (view && typeof url === "string" && url.trim()) {
      navigate(url.trim());
    }
  };

  const shouldShowSwitch = view && typeof url === "string" && url.trim().length > 0;

  return (
    <header className="bg-white text-black shadow-md w-full mb-4 relative z-20"
    style={{position: "sticky",
    top: 0,
    zIndex: 1000,}}>
      <div className="flex justify-between items-center w-full mx-auto p-2 px-4 md:px-6">
        <button className="flex items-center cursor-pointer">
          <img src={logo} alt="carret logo" className="h-10 md:h-14" />
        </button>

        <nav className="hidden md:flex space-x-8"></nav>

        <div className="flex items-center gap-2 md:gap-4">
          {shouldShowSwitch && (
            <button
              className="flex gap-1 md:gap-2 items-center cursor-pointer bg-[#543696] rounded-md p-1 px-2 text-white text-xs md:text-base"
              onClick={handleSwitch}
              type="button"
            >
              Switch
            </button>
          )}
          {
            <div
               className="flex gap-1 md:gap-2 items-center cursor-pointer rounded-md p-1 text-black text-xs md:text-base"
              style={{ display: logoutEnable ? "block" : "none" }}
            >{children}</div>
          }

          {logoutEnable && (
            <button
              className="flex gap-1 md:gap-2 items-center hover:text-gray-700 cursor-pointer text-xs md:text-base"
              onClick={logoutHandler}
              type="button"
            >
              <span className="hidden sm:inline">Logout</span>
              <LogoutOutlined />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
